export default [
    {
        path: '/parceiros', component: () => import('./components/Page'), name: 'parceiros.page', children: [
            {path: '', component: () => import('./components/Parceiros'), name: 'parceiros'},
            {path: 'registro', component: () => import('./components/Parceiro'), name: 'parceiros.new'},
            {path: ':id', component: () => import('./components/Parceiro'), name: 'parceiros.show'},
        ]
    }
]
